var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowItWorks5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 456,
    height: 608,
    viewBox: "0 0 456 608",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1217_9780",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 456,
    height: 608
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    rx: 40,
    fill: "#ECFFFA"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1217_9780)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 456,
    height: 608,
    fill: "#ECFFFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.939 188.835L184.781 213.676C179.351 216.822 176.028 222.577 176.028 228.868V337.243C176.028 340.567 177.815 343.677 180.744 345.285L186.889 348.752L207.075 330.022L245.767 308.576C251.197 305.431 254.52 299.676 254.52 293.385L237.942 194.089L228.904 188.799L228.939 188.835Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.979 194.125L193.285 219.289C187.855 222.434 184.532 228.189 184.532 234.48V344.392C184.532 348.467 188.962 351.04 192.499 349.003L215.614 335.67L254.306 314.224C259.737 311.079 263.059 305.324 263.059 299.033V210.46L237.979 194.161V194.125Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.979 215.428C237.979 219.503 242.409 222.077 245.946 220.039L263.059 210.424L237.979 194.125V215.464V215.428Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.195 243.164L237.977 250.206V236.123L250.195 229.081V243.164Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.331 252.743L219.148 259.785V236.551L231.331 229.51V252.743Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.754 262.894L200.535 269.936V237.516L212.754 230.475V262.894Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.832 293.565L233.19 270.117C239.014 268.365 244.016 270.295 246.302 275.943C249.91 284.986 245.016 300.213 235.405 309.971C225.759 319.693 215.041 320.265 211.433 311.222C210.933 309.971 210.611 308.648 210.433 307.183L228.903 293.565H228.832Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.505 302.035C210.934 297.317 212.541 292.099 215.149 287.237C217.079 283.592 219.579 280.16 222.473 277.193C226.082 273.548 229.869 271.189 233.37 270.116L229.047 293.421C229.047 293.421 228.94 293.528 228.904 293.493C228.904 293.493 228.976 293.6 228.904 293.636L210.576 307.147C210.362 305.538 210.362 303.787 210.505 302V302.035Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.539 127.105L308.288 122.458L316.576 117.49C316.934 117.239 317.291 117.025 317.648 116.846L317.827 116.739C320.578 115.488 323.972 115.774 327.687 117.99C329.831 119.277 331.832 121.064 333.689 123.209L339.191 119.885C339.549 119.634 339.906 119.42 340.263 119.241C343.836 117.382 348.409 117.704 353.375 120.671C364.629 127.391 373.632 145.227 373.417 160.454C373.417 161.776 373.31 163.063 373.167 164.243C379.312 169.997 383.814 180.256 383.707 189.227C383.635 194.482 381.992 198.306 379.419 200.272C379.062 200.558 378.669 200.773 378.24 200.951L370.023 205.848L362.449 197.52L362.914 196.162L316.112 168.996C307.931 164.1 301.393 151.16 301.536 140.08C301.643 131.394 305.787 126.461 311.539 127.069V127.105Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.322 132.823C303.501 122.993 310.254 118.919 318.256 123.708C320.9 125.281 323.401 127.676 325.58 130.571C329.081 123.673 336.012 121.671 343.908 126.389C355.162 133.109 364.165 150.945 363.951 166.172C363.951 167.494 363.843 168.781 363.7 169.961C369.845 175.715 374.347 185.974 374.24 194.946C374.097 205.49 367.702 210.28 359.878 205.597L306.645 174.715C298.464 169.818 291.926 156.878 292.069 145.798C292.176 137.005 296.463 132.037 302.287 132.823H302.322Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.188 154.914L338.836 163.385L330.905 175.359L324.188 154.914Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.37 159.847L333.693 162.349V145.942L329.37 143.44V159.847Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.19 405.654C126.76 395.253 121.437 379.168 111.076 373.02C109.112 371.841 106.432 370.268 104.932 369.339L104.253 362.44C104.824 362.154 105.432 361.833 106.003 361.439H106.075L106.289 361.225C107.718 360.26 108.826 359.08 109.254 357.043L110.076 353.433L112.899 340.78C113.006 340.386 113.113 339.993 113.184 339.564L113.256 339.243C113.399 338.278 113.506 337.277 113.542 336.169C113.685 325.088 106.039 311.505 96.5 305.822C92.1414 303.213 88.533 302.605 85.4605 303.928L85.0318 304.071L84.7817 304.214C84.4245 304.392 84.0672 304.571 83.7457 304.786L75.6715 309.254L75.2427 310.147L79.1727 313.114C79.0655 313.936 78.994 314.794 78.9583 315.723C78.9583 316.76 78.9583 317.582 79.0655 318.654L79.1369 318.904L79.2084 319.584C79.2798 320.191 79.3513 320.513 79.4942 321.121L82.6739 341.28C83.2098 344.854 85.1033 349.715 87.5327 353.29L86.711 358.759C85.2104 357.865 82.531 356.114 80.566 354.934C76.5289 352.539 73.5636 352.396 70.8484 353.719L70.4911 353.862L69.5622 354.398L62.5241 358.33L64.096 360.868C63.2386 362.476 62.5241 364.156 61.9524 365.729C60.7377 369.124 63.2743 374.879 66.9899 377.059L94.9281 393.645L96.1428 394.359L117.722 407.156C118.007 409.729 118.472 413.232 118.686 415.055C118.758 415.663 119.401 415.949 119.937 415.663L127.797 411.266C129.19 410.48 129.869 408.407 129.19 405.583V405.654Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.544 410.516C118.115 400.115 112.792 384.03 102.431 377.882C100.466 376.702 97.7865 375.13 96.286 374.2L95.6072 367.302C97.6436 366.301 100.037 364.836 100.609 361.905L101.431 358.294L104.253 345.641C104.36 345.248 104.467 344.855 104.539 344.426L104.61 344.104C104.753 343.139 104.86 342.138 104.896 341.03C105.039 329.95 97.3935 316.367 87.8545 310.684C78.3155 305.036 70.4914 309.433 70.3485 320.513C70.3485 321.55 70.3485 322.372 70.4557 323.444L70.5271 323.694L70.5986 324.374C70.6701 324.981 70.7415 325.303 70.8844 325.911L74.0641 346.07C74.6 349.644 76.4935 354.506 78.9229 358.08L78.1012 363.549C76.6007 362.655 73.8854 360.904 71.9562 359.724C61.5955 353.576 55.9507 363.156 53.3069 370.555C52.0922 373.95 54.6288 379.705 58.3444 381.885L86.2826 398.47L87.4973 399.185L115.328 415.699C119.044 417.879 121.652 415.234 120.544 410.445V410.516Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.953 340.395L105.983 340.248L105.954 340.102L105.056 335.449L112.251 331.391L112.785 337.655L109.172 353.925L108.714 355.473L108.714 355.475L107.477 359.723L103.847 361.789L103.426 362.028L103.471 362.51L104.069 368.958L96.8492 372.987L96.3379 367.792L97.1692 367.463L97.3333 367.398L97.4513 367.267L100.667 363.693L100.792 363.554L100.837 363.372L101.76 359.644L102.026 359.492L102.094 359.16L105.953 340.395Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.999 410.517L120.977 414.287L121.453 412.26L121.492 412.093L121.455 411.925L119.74 404.24L119.728 404.184L119.707 404.131L119.366 403.257L126.366 399.079L128.272 404.315L128.576 407.995L127.999 410.517Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.086 349.216C241.086 377.167 265.451 390.035 276.384 390.035C281.921 390.035 287.173 389.249 292.139 387.819",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.279 361.548C179.279 380.421 162.809 389.106 155.449 389.106C151.698 389.106 148.161 388.57 144.803 387.605",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.781 261.716C314.361 255.032 329.152 228.939 329.152 205.134",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "8 8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.917 379.027C362.912 370.377 338.618 370.377 323.613 379.027C314.86 384.066 311.252 390.965 312.716 397.542C313.395 400.509 315.11 403.44 317.861 406.085C319.433 407.622 321.327 409.051 323.613 410.374C338.618 419.024 362.912 419.024 377.917 410.374C380.204 409.051 382.097 407.586 383.669 406.085C386.42 403.44 388.135 400.509 388.814 397.542C390.279 390.965 386.67 384.066 377.917 379.027Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.153 392.323C340.019 392.323 345.585 386.754 345.585 379.884C345.585 373.014 340.019 367.445 333.153 367.445C326.286 367.445 320.72 373.014 320.72 379.884C320.72 386.754 326.286 392.323 333.153 392.323Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.696 361.334C365.562 361.334 371.128 355.765 371.128 348.895C371.128 342.025 365.562 336.456 358.696 336.456C351.829 336.456 346.263 342.025 346.263 348.895C346.263 355.765 351.829 361.334 358.696 361.334Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.447 420.133C366.314 420.133 371.88 414.563 371.88 407.694C371.88 400.824 366.314 395.255 359.447 395.255C352.581 395.255 347.015 400.824 347.015 407.694C347.015 414.563 352.581 420.133 359.447 420.133Z",
    fill: "#ECFFFA",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.813 397.543C388.135 400.51 386.42 403.441 383.669 406.086C382.097 407.623 380.203 409.052 377.917 410.375C362.912 419.025 338.618 419.025 323.612 410.375C321.326 409.052 319.432 407.587 317.86 406.086C315.11 403.441 313.395 400.51 312.716 397.543L323.648 450.73C323.648 450.73 324.934 456.306 327.471 458.772C328.578 459.844 329.936 460.881 331.544 461.81C342.155 467.922 359.339 467.922 369.95 461.81C371.558 460.881 372.915 459.844 374.023 458.772C376.595 456.306 377.881 450.73 377.845 450.73L388.778 397.543H388.813Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.758 384.246L337.511 375.524",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.758 375.524L337.511 384.246",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.303 353.578L363.056 344.82",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.303 344.82L363.056 353.578",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09 412.054L363.807 403.333",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.09 403.333L363.807 412.054",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403 456.413C403 463.061 401.75 468.03 399.499 472.784C397.356 477.359 394.462 481.362 390.711 484.794C387.102 488.082 382.994 490.584 378.17 491.692C373.776 492.693 369.489 492.443 365.452 490.298C361.915 488.404 359.45 485.508 357.806 481.898C356.163 478.252 355.556 474.392 355.734 470.46C356.127 462.489 358.985 455.448 363.844 449.157C367.06 444.975 371.025 441.651 375.813 439.399C378.956 437.933 382.208 437.076 385.673 437.219C392.39 437.505 397.284 440.721 400.392 446.655C402.214 450.158 402.965 453.947 402.929 456.484L403 456.413Z",
    fill: "#00C495",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.487 490.262C361.95 488.368 359.485 485.472 357.841 481.862C356.198 478.217 355.59 474.356 355.769 470.424C356.162 462.454 359.02 455.412 363.879 449.121C367.094 444.939 371.06 441.615 375.847 439.363C378.991 437.898 382.242 437.04 385.708 437.183C388.745 437.29 391.388 438.076 393.711 439.399L385.279 434.43C382.957 433.072 380.242 432.322 377.169 432.179C373.704 432.036 370.417 432.893 367.309 434.359C362.486 436.575 358.556 439.935 355.34 444.117C350.481 450.372 347.623 457.449 347.23 465.42C347.052 469.388 347.659 473.248 349.302 476.858C350.767 480.111 352.947 482.827 355.912 484.722L365.487 490.262Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.21 446.153L384.351 450.121L368.917 484.792L376.134 480.646L391.21 446.153Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.951 460.594L371.882 457.484L392.067 471.353L386.172 474.463L365.951 460.594Z",
    fill: "#0F1936",
    stroke: "#0F1936",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorks5);
export default __webpack_public_path__ + "static/media/howItWorks5.2b6e4299f724f4df02a988bd7c3756b7.svg";
export { ForwardRef as ReactComponent };